export const getNextItemId = (items = []) => {
  let maxNumber = 0;
  let maxDigits = 4;

  items.forEach((item) => {
    const itemId = item && item.itemId;
    const match = typeof itemId === "string" && itemId.match(/^ITM-(\d+)$/);

    if (!match) {
      return;
    }

    const number = parseInt(match[1], 10);
    if (number > maxNumber) {
      maxNumber = number;
      maxDigits = Math.max(4, match[1].length);
    }
  });

  return `ITM-${String(maxNumber + 1).padStart(maxDigits, "0")}`;
};
